export const maskTypes = {
    product_quantity: {
        mask: '*{1,20}',
        definitions: {
            '*': {
                // eslint-disable-next-line
                validator: '[0-9]',
            },
        },
    },

    phone: {
        mask: '+7 (999) 999-99-99',
        onBeforePaste: (pastedValue) => {
            const processedValue = pastedValue;
            if (pastedValue.length === 11) {
                return pastedValue.substr(1);
            }

            return processedValue;
        },
    },

    email: {
        mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]',
        greedy: false,
        onBeforePaste(pastedValue) {
            const pasted = pastedValue.toLowerCase();
            return pasted.replace('mailto:', '');
        },
        definitions: {
            '*': {
                // eslint-disable-next-line
                validator: '[0-9A-Za-z!#$%&\'*+/=?^_`{|}~\-]',
                casing: 'lower',
            },
        },
    },

    date: {
        alias: 'datetime',
        inputFormat: 'dd.mm.yyyy',
        placeholder: '_',
    },

    smscode: {
        mask: '9{4}',
        placeholder: '_',
    },
};
